export default __webpack_public_path__ + "static/media/mid.e970b0db.svg";